import React from 'react';

/**
 * ConversionTwoPathsSection
 *
 * Props:
 * - onUpgrade: callback when the user chooses to order the professional report
 */
const ConversionTwoPathsSection = ({ onUpgrade }) => {
  return (
    <div className="bg-gray-900 rounded-2xl p-8 text-center text-white mb-8">
      <h3 className="text-3xl font-bold mb-4">Two Ways to Get Your Professional Report</h3>
      <p className="text-xl text-gray-300 mb-8">
        Choose the path that works best for your decision-making process
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-800 rounded-xl p-6 border-2 border-emerald-500">
          <div className="text-emerald-400 font-bold text-lg mb-2">
            Option 1: Get Started Now
          </div>
          <h4 className="text-xl font-bold mb-4">Order Professional Report</h4>
          <ul className="text-left space-y-2 mb-6 text-gray-300">
            <li>✓ Complete analysis of your facility</li>
            <li>✓ 18-month implementation roadmap</li>
            <li>✓ Grant matching ($125K+ typical)</li>
            <li>✓ $500K+ annual value guarantee</li>
            <li>✓ Delivered within 48 hours</li>
          </ul>
          <button
            onClick={onUpgrade}
            className="w-full bg-emerald-600 text-white py-3 px-6 rounded-lg font-bold text-lg hover:bg-emerald-700 transition-colors"
          >
            Order Report - $990
          </button>
        </div>

        <div className="bg-gray-800 rounded-xl p-6 border-2 border-blue-500">
          <div className="text-blue-400 font-bold text-lg mb-2">Option 2: Preview First</div>
          <h4 className="text-xl font-bold mb-4">Review Sample Report</h4>
          <ul className="text-left space-y-2 mb-6 text-gray-300">
            <li>✓ See actual report format & depth</li>
            <li>✓ Real case study: $315K savings</li>
            <li>✓ Implementation roadmaps shown</li>
            <li>✓ Grant opportunities detailed</li>
            <li>✓ No commitment required</li>
          </ul>
          <a
            href="https://consultant-comms.preview.emergentagent.com/sample-reports/patties-energy-assessment-report.html"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-bold text-lg hover:bg-blue-700 transition-colors block text-center"
          >
            View Sample Report
          </a>
        </div>
      </div>

      <p className="text-sm text-gray-400 mt-6">
        Questions? Call 1-800-RAMP-ENERGY or email support@relyability.ai
      </p>
    </div>
  );
};

export default ConversionTwoPathsSection;


